import React, { forwardRef } from 'react';
import Button from 'components/CustomButtons/Button';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Warning from 'assets/img/warning.svg';
import styles from 'assets/jss/material-dashboard-pro-react/components/confirmationDialogStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { DisplayS } from 'components/Typography/Typography';
import { TransitionProps } from '@material-ui/core/transitions';
import { SlideProps } from '@material-ui/core/Slide/Slide';
import CustomCircularProgress from '../CustomCircularProgress/CustomCircularProgress';
import { translate } from '../Translation';
import ConditionalRender from '../ConditionalRender/ConditionalRender';
import Close from '@material-ui/icons/Close';

// @ts-ignore
const useStyles = makeStyles(styles);

const Transition = forwardRef(function Transition(props: SlideProps, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

interface IConfirmationDialogButton {
	text: string | React.ReactElement;
	color: types.theme.buttonColor;
	onClick: Function;
	disabled?: boolean;
}
interface IConfirmationDialogProps {
	isOpen: boolean;
	hideDialog: Function;
	header: string;
	className?: string;
	dialogBody?: string | React.ReactElement;
	buttons: IConfirmationDialogButton[];
	loading?: boolean;
	withIcon?: boolean;
}

const ConfirmationDialog = ({
	isOpen,
	header,
	dialogBody,
	hideDialog,
	buttons,
	className,
	loading,
	withIcon = true,
}: IConfirmationDialogProps) => {
	const classes = useStyles();

	return (
		<Dialog
			open={isOpen}
			TransitionComponent={Transition as React.ComponentType<TransitionProps>}
			keepMounted
			onClose={() => hideDialog()}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description"
			className={classNames({ [classes.dialog]: true, [className ? className : '']: true })}
		>
			<button className={classes.dialogCloseButton} onClick={() => hideDialog()}>
				<Close />
			</button>
			{withIcon && <img src={Warning} alt="Warning" />}
			<DisplayS>{header}</DisplayS>
			<div className={classes.dialogBody}>{dialogBody}</div>
			{buttons && buttons.length > 0 && (
				<div className={classes.buttonsWrapper}>
					{buttons.map((button, index) => (
						<Button key={index} color={button.color} onClick={button.onClick} disabled={button.disabled}>
							{button.text}
						</Button>
					))}
				</div>
			)}
			<ConditionalRender
				show={!!loading}
				onTrue={() => (
					<div className={classes.loadingWrapper}>
						<CustomCircularProgress text={translate('loading.it.can.take.a.while')} loading transparent />
					</div>
				)}
			/>
		</Dialog>
	);
};

export default ConfirmationDialog;
